module.exports = { THEME: process.env.NX_THEME };
